import gql from 'graphql-tag'

export const ProductVariantFields = gql`
  fragment ProductVariantFields on ProductVariant {
    sku
    title
    __typename
    images {
      thumbnail
      largeProduct
      zoom
      __typename
    }
    price(currency: $currency, shippingDestination: $shippingDestination) {
      price {
        amount
        displayValue
      }
      rrp {
        amount
        displayValue
      }
    }
    product {
      cheapestVariant(
        currency: $currency
        shippingDestination: $shippingDestination
      ) {
        price(currency: $currency, shippingDestination: $shippingDestination) {
          price {
            amount
            displayValue
          }
          rrp {
            amount
            displayValue
          }
        }
      }
      reviews {
        averageScore
        total
        __typename
      }
      url
      __typename
    }
  }
`
